import { LicenseRequestsService } from "~/entity/Licenses/api/licenseRequestsService";
import {
  ILicenseRequestsListParams,
  IPendingLicenseRequestsParams,
} from "~/entity/Licenses/model/schema";

export const useLicenseRequests = () => {
  const queryKeys = {
    all: [LicenseRequestsService._routes.root],
    list: (params?: ILicenseRequestsListParams) => [
      LicenseRequestsService._routes.root,
      params,
    ],
    pending: (params?: IPendingLicenseRequestsParams) => [
      LicenseRequestsService._routes.pending,
      params,
    ],
    byId: (id?: string) => [LicenseRequestsService._routes.root, "byId", id],
  };

  const getLicenseRequestsList = LicenseRequestsService.GET.list;
  const getPendingRequests = LicenseRequestsService.GET.pending;
  const getLicenseRequestById = LicenseRequestsService.GET.byId;
  const getCalculateStatus = LicenseRequestsService.GET.calculateStatus;
  const createRequest = LicenseRequestsService.POST.create;
  const calculateRequest = LicenseRequestsService.POST.calculate;
  const approveCalculateRequest = LicenseRequestsService.POST.approveCalculate;
  const transitionRequest = LicenseRequestsService.PUT.transition;
  const updateRequest = LicenseRequestsService.PUT.update;
  const recalculateRequest = LicenseRequestsService.PUT.recalculate;

  return {
    queryKeys,
    getLicenseRequestsList,
    getPendingRequests,
    getLicenseRequestById,
    getCalculateStatus,
    createRequest,
    calculateRequest,
    approveCalculateRequest,
    transitionRequest,
    updateRequest,
    recalculateRequest,
  };
};
